const Customer = {
  Name: "Customer.Name",
  NoName: "Customer.NoName",
  AllCustomers: "Customer.AllCustomers",
  Customers: "Customer.Customers",
  HighestInvoicedAmount: "Customer.HighestInvoicedAmount",
  OrgOrPersonNumber: "Customer.OrgOrPersonNumber",
  OrgNumberForBRF: "Customer.OrgNumberForBRF",
  ApartmentNumber: "Customer.ApartmentNumber",
  AutoReminders: "Customer.AutoReminders",
  ReminderRate: "Customer.ReminderRate",
  PaymentTerms: "Customer.PaymentTerms",
  RefCode: "Customer.RefCode",
  MonthlyCost: "Customer.MonthlyCost",
  CreateQuote: "Customer.CreateQuote",
  ImportCustomers: "Customer.ImportCustomers",
  ExportCustomers: "Customer.ExportCustomers",
  TodoDescription: "Customer.TodoDescription",
  InvoiceDraft: "Customer.InvoiceDraft",
  HelpTextName: "Customer.HelpTextName",
  HelpTextRating: "Customer.HelpTextRating",
  HelpTextRecurringInvoices: "Customer.HelpTextRecurringInvoices",
  HelpTextSentInvoices: "Customer.HelpTextSentInvoices",
  HelpTextPurchasedAmount: "Customer.HelpTextPurchasedAmount",
  HelpTextUnpaidAmount: "Customer.HelpTextUnpaidAmount",
  CustomerSettings: "Customer.CustomerSettings",
  AutogiroHelpText: "Customer.AutogiroHelpText",
  RemoveCustomer: "Customer.RemoveCustomer",
  RemoveCustomerTitle: "Customer.RemoveCustomerTitle",
  RemoveCustomerDescriptionText: "Customer.RemoveCustomerDescriptionText",
  ActivateCustomerDescriptionText: "Customer.ActivateCustomerDescriptionText",
  RemoveCustomerSuccess: "Customer.RemoveCustomerSuccess",
  ExportCustomerRegisterToCSV: "Customer.ExportCustomerRegisterToCSV",
  ExportCustomerRegisterToEXCEL: "Customer.ExportCustomerRegisterToEXCEL",
  ImportCustomerRegister: "Customer.ImportCustomerRegister",
  OrgNr: "Customer.OrgNr",
  GlnNr: "Customer.GlnNr",
  StandardPaymentTerms: "Customer.StandardPaymentTerms",
  IncludeVatNumberOnInvoice: "Customer.IncludeVatNumberOnInvoice",
  BillingAddress: "Customer.BillingAddress",
  BillingAddress2: "Customer.BillingAddress2",
  DeliveryAddress: "Customer.DeliveryAddress",
  DeliveryAddress2: "Customer.DeliveryAddress2",
  VATNr: "Customer.VATNr",
  DisableCustomerDescriptionText: "Customer.DisableCustomerDescriptionText",
  CustomerImportSuccess: "Customer.CustomerImportSuccess",
  ImportFileSectionDescription: "Customer.ImportFileSectionDescription",
  ReferencePersons: "Customer.ReferencePersons",
  ReferencePersonName: "Customer.ReferencePersonName",
  ReferencePersonEmail: "Customer.ReferencePersonEmail",
  ReferencePersonPhone: "Customer.ReferencePersonPhone",
  ReferencePersonId: "Customer.ReferencePersonId",
  ReferencePersonDefault: "Customer.ReferencePersonDefault",
  ImportOrgNrDescription: "Customer.ImportOrgNrDescription",
  ImportPhone: "Customer.ImportPhone",
  ImportBillingAddressDescription: "Customer.ImportBillingAddressDescription",
  ImportDeliveryAddressDescription: "Customer.ImportDeliveryAddressDescription",
  ImportIncludeVATNumberDescription: "Customer.ImportIncludeVATNumberDescription",
  ImportPaymentTermsDescription: "Customer.ImportPaymentTermsDescription",
  ImportShowCurrencyCode: "Customer.ImportShowCurrencyCode",
  ImportShowCurrencyCodeDescription: "Customer.ImportShowCurrencyCodeDescription",
  ImportLanguage: "Customer.ImportLanguage",
  ImportLanguageDescription: "Customer.ImportLanguageDescription",
  ImportReferencePersonDescription: "Customer.ImportReferencePersonDescription",
  ImportReferencePersonNameDescription: "Customer.ImportReferencePersonNameDescription",
  ImportReferencePersonIdDescription: "Customer.ImportReferencePersonIdDescription",
  ImportReferencePersonIsDefaultDescription: "Customer.ImportReferencePersonIsDefaultDescription",
  InvoiceManagement: "Customer.InvoiceManagement",
  SettingType_Standard: "Customer.SettingType_Standard",
  SettingType_CustomerSpecific: "Customer.SettingType_CustomerSpecific",
  InvoiceSending: "Customer.InvoiceSending",
  ReminderSending: "Customer.ReminderSending",
  InvoiceSendingDescription: "Customer.InvoiceSendingDescription",
  GoToStandardSettings: "Customer.GoToStandardSettings",
  InvoiceDeliveryMethod: "Customer.InvoiceDeliveryMethod",
  InvoiceReminderDeliveryMethod: "Customer.InvoiceReminderDeliveryMethod",
  InvoiceDeliveryMethodDescription: "Customer.InvoiceDeliveryMethodDescription",
  InvoiceReminderDeliveryMethodDescription: "Customer.InvoiceReminderDeliveryMethodDescription",
  Billing: "Customer.Billing",
  AutomaticReminderSendType_SendByEmail: "Customer.AutomaticReminderSendType_SendByEmail",
  AutomaticReminderSendType_SendForPrintOrEInvoice: "Customer.AutomaticReminderSendType_SendForPrintOrEInvoice",
  InvoiceSendToType: "Customer.InvoiceSendToType",
  InvoiceCustomSendToEmail: "Customer.InvoiceCustomSendToEmail",
  Rating_Bad: "Customer.Rating_Bad",
  Rating_Average: "Customer.Rating_Average",
  Rating_Good: "Customer.Rating_Good",
  ImportWithoutOrgNr: "Customer.ImportWithoutOrgNr",
  ImportWithoutCity: "Customer.ImportWithoutCity",
  ImportSkipTheseCustomers: "Customer.ImportSkipTheseCustomers",
  ImportInvalidOrgNrTitle: "Customer.ImportInvalidOrgNrTitle",
  ImportInvalidOrgNrDescription: "Customer.ImportInvalidOrgNrDescription",
  ImportMissingCityTitle: "Customer.ImportMissingCityTitle",
  ImportMissingCityDescription: "Customer.ImportMissingCityDescription",
  GlnHelp: "Customer.GlnHelp",
  GlnFilled: "Customer.GlnFilled",
  GlnNoResults: "Customer.GlnNoResults",
  GlnLookupFailed: "Customer.GlnLookupFailed",
  GlnOrganisationRequired: "Customer.GlnOrganisationRequired",
  GlnSelectRecipient: "Customer.GlnSelectRecipient",
  GlnUseSelection: "Customer.GlnUseSelection",
  GlnSelectionHelp: "Customer.GlnSelectionHelp",
  }
export default Customer;